import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function NewContact() {
    const navigate = useNavigate();
    const bgStyle = {
        backgroundImage: 'url("/Images/contact.png")',
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "10vh",
    };

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phoneNumber: "",
        message: "",
        subject: "",
    });

    const handleChange = (e: any) => {
        setFormData((f) => ({ ...f, [e.target.name]: e.target.value }));
    };

    const handleSubmit = () => {
        const { name, email, phoneNumber, message, subject } = formData;
        const mailto = `mailto:wetacre0@gmail.com?subject=${subject || "Contact from Website"
            }&body=${encodeURIComponent(
                message + "\n\nFrom: " + name + "\nPhone: " + phoneNumber
            )}`;
        window.location.href = mailto;
    };

    const handleReset = () =>
        setFormData({ name: "", email: "", phoneNumber: "", message: "", subject: "" });

    return (
        <section id="contact" className="w-full">
            {/* header */}
            <div style={bgStyle} className="flex items-center px-4 text-white justify-center text-4xl">
                Contact Us
            </div>

            {/* main */}
            <div className="flex flex-col xl:flex-row xl:items-start xl:justify-between xl:px-24 xl:py-10 px-4 py-8 gap-10">
                {/* left form */}
                <div className="w-full xl:w-1/2 space-y-4">
                    <h2 className="text-[#3390FF] font-semibold text-lg">Send Us Email</h2>
                    <h1 className="text-3xl font-semibold">Feel Free to Write</h1>

                    {/* two-per-row inputs */}
                    <div className="flex flex-wrap gap-4">
                        <input
                            name="name"
                            type="text"
                            placeholder="Enter Name"
                            value={formData.name}
                            onChange={handleChange}
                            className="flex-1 min-w-[calc(50%-1rem)] bg-[#EBF4FF] placeholder-[#616161] rounded p-2"
                        />
                        <input
                            name="email"
                            type="email"
                            placeholder="Enter Email"
                            value={formData.email}
                            onChange={handleChange}
                            className="flex-1 min-w-[calc(50%-1rem)] bg-[#EBF4FF] placeholder-[#616161] rounded p-2"
                        />
                        <input
                            name="subject"
                            type="text"
                            placeholder="Enter Subject"
                            value={formData.subject}
                            onChange={handleChange}
                            className="flex-1 min-w-[calc(50%-1rem)] bg-[#EBF4FF] placeholder-[#616161] rounded p-2"
                        />
                        <input
                            name="phoneNumber"
                            type="tel"
                            placeholder="Enter Phone"
                            value={formData.phoneNumber}
                            onChange={handleChange}
                            className="flex-1 min-w-[calc(50%-1rem)] bg-[#EBF4FF] placeholder-[#616161] rounded p-2"
                        />
                    </div>

                    {/* full-width textarea */}
                    <textarea
                        name="message"
                        placeholder="Enter Message"
                        value={formData.message}
                        onChange={handleChange}
                        className="w-full bg-[#EBF4FF] placeholder-[#616161] rounded p-2 h-32 resize-none"
                    />

                    {/* buttons */}
                    <div className="flex gap-4">
                        <button
                            onClick={handleSubmit}
                            className="bg-[#3FC041] text-white px-6 py-2 rounded hover:bg-blue-600 transition"
                        >
                            Send Message
                        </button>
                        <button
                            onClick={handleReset}
                            className="bg-[#3FC041] text-white px-6 py-2 rounded hover:bg-blue-600 transition"
                        >
                            Reset
                        </button>
                    </div>
                </div>

                {/* right info box */}
                <div className="w-full xl:w-[40%] border-2 border-[#3390FF] rounded-lg p-8 flex flex-col
             space-y-4">

                    <h3 className="text-[#3390FF] text-lg font-semibold text-left">
                        Need Any Help?
                    </h3>
                    <h2 className="text-2xl font-semibold text-left">
                        Get in Touch with us
                    </h2>
                    <p className="text-[#3390FF] text-left">
                        At KrishiYan, we are dedicated to providing innovative solutions for farmers and
                        Farmer Producer Organizations (FPOs). Reach out to us and let’s work together to
                        cultivate growth and sustainability.
                    </p>

                    <div className="flex flex-col space-y-6">
                        {/* 1st: center icon+text */}
                        <div className="flex items-center gap-10">
                            <div className="bg-[#3FC041] p-3 rounded">
                                <img src="/Images/material-symbols_call.png" alt="Call" className="h-6 w-6" />
                            </div>
                            <div className="text-left">
                                <h4 className="font-semibold text-xl">Have a Question?</h4>
                                <p>+91 70667 44494</p>
                            </div>
                        </div>

                        {/* 2nd: center icon+text */}
                        <div className="flex items-center gap-10">
                            <div className="bg-[#3FC041] p-3 rounded">
                                <img src="/Images/material-symbols_mail.png" alt="Mail" className="h-6 w-6" />
                            </div>
                            <div className="text-left">
                                <h4 className="font-semibold text-xl">Email Us</h4>
                                <p>info@krishiyan.com</p>
                            </div>
                        </div>

                        {/* 3rd: top-align for multiline */}
                        <div className="flex  gap-10 items-center">
                            <div className="bg-[#3FC041] p-3 rounded">
                                <img
                                    src="/Images/mdi_location.png"
                                    alt="Location"
                                    className="h-6 w-10 xl:w-6 md:w-6 sm:w-6"
                                />
                            </div>
                            <div className="text-left leading-relaxed">
                                <h4 className="font-semibold text-xl">Contact Us</h4>
                                <p>
                                    WetAcre Sustainable Solution Private Limited,
                                    <br />
                                    CrAdLE, Village Bhat, Gandhinagar, Gujarat,
                                    <br />
                                    382428 – India.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    );
}
